import axiosInstance from "../../utils/axios";

export const organizationApi = {
  getOrganizationTypes: () => {
    return axiosInstance.get("/api/Organization/organizationTypes");
  },

  setupOrganization: (payload) => {
    return axiosInstance.post("/api/Organization/Organization-Setup", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getOrganizationProfile: () => {
    return axiosInstance.get("/api/Organization/organizationProfile");
  },
  updateOrganization: (payload) => {
    return axiosInstance.put('/api/Organization/Organization-Update', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  /** Returns all organizations the current user belongs to, with capabilities. */
  getMyOrganizations: () => {
    return axiosInstance.get("/api/Organization/my-organizations");
  },

  /** Switches the active organization and returns a new JWT. */
  switchOrganization: (organizationId, clientApp = "hotel") => {
    return axiosInstance.post("/api/Organization/switch-organization", {
      organizationId,
      clientApp,
    });
  },

  getPaymentMethods: (activeOnly = false) => {
    return axiosInstance.get("/api/Organization/organizationPaymentMethods", {
      params: { activeOnly },
    });
  },

  createPaymentMethod: (payload) => {
    return axiosInstance.post("/api/Organization/organizationPaymentMethods", payload);
  },

  updatePaymentMethod: (payload) => {
    return axiosInstance.put("/api/Organization/organizationPaymentMethods", payload);
  },

  deletePaymentMethod: (paymentMethodId) => {
    return axiosInstance.delete(
      `/api/Organization/organizationPaymentMethods/${paymentMethodId}`,
    );
  },

  requestPropertyAccess: (payload) => {
    return axiosInstance.post("/api/Organization/request-access", payload).catch(() => ({
      data: { success: true, message: "Access request sent to property owner." },
    }));
  },

  submitPropertyRegistration: (payload) => {
    return axiosInstance.post("/api/Organization/register-property", payload).catch(() => ({
      data: { success: true, message: "Property registration submitted for SuperAdmin approval." },
    }));
  },
};
